import Reveal from "@/components/motion/Reveal";
import KineticText from "@/components/motion/KineticText";
import EnquiryForm from "@/components/EnquiryForm";
import { T, useContent } from "@/content/ContentContext";

const IMG = "https://images.pexels.com/photos/4173250/pexels-photo-4173250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function ContactPage() {
  const { t } = useContent();
  return (
    <div data-testid="contact-page">
      <section className="bg-brand-night text-brand-bone texture-grain pt-40 pb-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <p className="overline-label text-brand-gold" data-testid="contact-overline">{t("contact.hero.overline")}</p>
          <KineticText
            className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight font-medium leading-[0.98]"
            lines={[<T key="1" k="contact.hero.line1" />, <T key="2" k="contact.hero.line2" em="text-brand-gold" />]}
          />
          <p className="mt-8 max-w-2xl text-base lg:text-lg font-light leading-relaxed text-brand-bone/70">
            {t("contact.hero.intro")}
          </p>
        </div>
      </section>

      <section className="bg-brand-bone py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-serif text-3xl lg:text-4xl tracking-tight font-medium text-brand-ink mt-4 mb-10" data-testid="form-heading">{t("contact.form.heading")}</h2>
              <EnquiryForm idPrefix="contact" />
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="relative hidden lg:block">
                <div className="absolute -top-4 -right-4 h-full w-full border border-brand-gold/50" aria-hidden="true" />
                <img src={IMG} alt="Healthcare professional on a call" className="relative h-[380px] w-full object-cover" data-testid="contact-image" />
              </div>
              <div className="mt-10 lg:mt-14 space-y-8">
                <div>
                  <p className="overline-label text-brand-green">{t("contact.next.heading")}</p>
                  <ol className="mt-5 space-y-4 text-sm font-light text-brand-ink/70 leading-relaxed">
                    {[1, 2, 3].map((i) => (
                      <li key={i} className="flex gap-4">
                        <span className="font-sans font-bold text-brand-gold">0{i}</span>
                        {t(`contact.next.${i}`)}
                      </li>
                    ))}
                  </ol>
                </div>
                <div className="border-t border-brand-ink/10 pt-8">
                  <p className="overline-label text-brand-green">{t("contact.location.heading")}</p>
                  <p className="mt-3 font-serif text-2xl text-brand-ink">{t("contact.location.title")}</p>
                  <p className="mt-1 text-sm font-light text-brand-ink/60">{t("contact.location.sub")}</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
